import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { appConfig, clientConfig } from "../../shared/constant/app.constant";
import { AppFlowService } from "../../shared/services/app-flow/app-flow.service";
import { CopyHelpers } from "../../shared/helpers/copy.helpers";
import { Store, select } from "@ngrx/store";
import { ThemeService } from "../../shared/theme/theme.service";

@Component({
  selector: "app-d-landing-page",
  templateUrl: "./d-landing-page.component.html",
  styleUrls: ["./d-landing-page.component.scss"],
})
export class DLandingPageComponent implements OnInit,OnDestroy {
  brandInfo: BrandingInfo = {
    logoSrc: clientConfig.LOGO_URL, //this.getSampleBase64Image(),
    title: clientConfig.TITLE,
    policyUrl: clientConfig.POLICYURL,
  };
  flowSteps = [];
  returnOrder: any;
  isTechSupportAvailable: boolean = true;
  subscription:any;

  constructor(private route: ActivatedRoute, private appFlowService: AppFlowService,private store: Store<AppState>, private router: Router,private themeService: ThemeService) {
    console.log("flow step", appFlowService.activeStepId);
    const activeFlow = this.appFlowService.getActiveAppFlow();
    this.flowSteps = activeFlow.steps;


    this.store.pipe(select("returnOrder")).subscribe((items) => {
      this.returnOrder = CopyHelpers.deepCopy(items);
    });

    if (clientConfig.APPFLOW === "formPostOrderB2CTechSupportFlow") {

      if (!clientConfig.TECH_SUPPORT_CONFIG ||
        !clientConfig.TECH_SUPPORT_CONFIG.techSupportAssessment ||
        clientConfig.TECH_SUPPORT_CONFIG.techSupportAssessment.length === 0
      )
      {
        this.isTechSupportAvailable = false;
      }
      else if(this.returnOrder &&
        clientConfig.TECH_SUPPORT_CONFIG &&
        clientConfig.TECH_SUPPORT_CONFIG.techSupportAssessment &&
        clientConfig.TECH_SUPPORT_CONFIG.techSupportAssessment.length !== 0)
        {
          const orderLineAssessmentIds = this.returnOrder.orderLines
          .filter((o) => o.returnable === true && o.assessmentId)
          .map((orderLine) => orderLine.assessmentId);
          const techSupportAssessment = clientConfig.TECH_SUPPORT_CONFIG.techSupportAssessment.filter((assessment) =>
            orderLineAssessmentIds.includes(assessment.assessmentId)
          );
          if (!techSupportAssessment || techSupportAssessment.length === 0) {
            this.isTechSupportAvailable = false;
          }
        }
    }

    if(!this.isTechSupportAvailable)
    {
      this.appFlowService.getActiveAppFlow();
      let index = activeFlow.steps.findIndex(x => x === "techSupport");
      activeFlow.steps.splice(1,index);
      this.appFlowService.setActiveAppFlow(activeFlow);
      this.flowSteps = activeFlow.steps;
    }

    console.log("flowservice", appFlowService);
    console.log("flow", activeFlow);
    console.log("step", this.flowSteps); 
  }
 
  ngOnInit() {
    if (clientConfig.MERCHANTCONFIG_IN_DB && clientConfig.MERCHANTCONFIG_IN_DB.toLowerCase().trim() === "true") {
      this.subscription=this.themeService.logo$.subscribe(logo => {
          this.brandInfo.logoSrc = logo.data
      });
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  checkIfErrorPage() {
    return this.router && this.router.url ? this.router.url.includes("globalerror") : false;
  }

  handleImageError(event:any)
  {
    if (event.target.dataset.errorHandled) {
      return;
    }
      // Handle the error, set a fallback image
      if (clientConfig.MERCHANTNAME.toLowerCase().includes("sony"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/sony.png`;
      else if (clientConfig.MERCHANTNAME.toLowerCase().includes("schneider"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/schneider.png`;
      else if (clientConfig.MERCHANTNAME.toLowerCase().includes("starlink"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/starlink.png`;
      else if (clientConfig.TENANTNAME.toLowerCase().includes("kuehnenagel"))
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/kuehnenagel.png`;
      else
        event.target.src=`${appConfig.NG_APP_ROOT}/assets/i18n/images/centiro.png`;

        event.target.dataset.errorHandled = 'true';
  }
}
